import React from 'react';
import './ServicePages.css';

const BiPage = ({ onContactClick }) => {
  const features = [
    { icon: "📊", title: "Executive Dashboards", desc: "Real-time C-suite dashboards that provide instant visibility into company-wide performance metrics." },
    { icon: "📈", title: "KPI Tracking", desc: "Define, track, and alert on key performance indicators across departments and business units." },
    { icon: "🔄", title: "Automated Reporting", desc: "Schedule and distribute custom reports automatically to stakeholders — daily, weekly, or monthly." },
    { icon: "🧩", title: "Data Integration", desc: "Connect to 100+ data sources — databases, APIs, spreadsheets, and cloud services — in one platform." },
    { icon: "🎯", title: "Self-Service Analytics", desc: "Empower non-technical users to build their own reports and explore data without SQL knowledge." },
    { icon: "🔮", title: "What-If Analysis", desc: "Model different business scenarios and understand the potential impact of decisions before making them." }
  ];

  return (
    <div className="service-page theme-bi">
      <section className="svc-hero">
        <div className="svc-hero-content">
          <h1 className="svc-hero-title">Business<br/>Intelligence</h1>
          <p className="svc-hero-subtitle">DATA-DRIVEN DECISIONS FOR EVERY TEAM.</p>
          <p className="svc-hero-desc">Transform your organization with powerful BI solutions that turn complex data into clear, actionable insights for every stakeholder.</p>
          <div className="svc-hero-stats">
            <div className="svc-stat-item"><h3>60%</h3><p>Faster Reporting</p></div>
            <div className="svc-stat-item"><h3>100+</h3><p>Data Connectors</p></div>
            <div className="svc-stat-item"><h3>5x</h3><p>Decision Speed</p></div>
          </div>
          <div className="svc-hero-cta">
            <button className="svc-btn-primary" onClick={onContactClick}>Book a Call</button>
            <button className="svc-btn-secondary"><span>▶</span> See Demo</button>
          </div>
        </div>
        <div className="svc-hero-visual">
          <div className="svc-glowing-ring">📈</div>
        </div>
      </section>

      <section className="svc-features-section">
        <h2 className="svc-section-title">BI Platform Capabilities</h2>
        <div className="svc-features-grid">
          {features.map((f, i) => (
            <div key={i} className="svc-feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="svc-cta-section">
        <div className="svc-cta-content">
          <h2>Ready to see your data clearly?</h2>
          <p>Book a call and we'll build a BI strategy that transforms how your organization makes decisions.</p>
          <button className="svc-btn-cta" onClick={onContactClick}>Book a Call</button>
        </div>
      </section>
    </div>
  );
};

export default BiPage;
